import {
  seoSegmentationListingPage,
  seoSegmentationListingPage_seoSegmentationStats_SEOSegmentationStatsSuccess as SEOSegmentationStatsSuccess,
} from '@/__generated__/seoSegmentationListingPage';

export const narrowSegmentationStats = (
  seoSegmentationStats: seoSegmentationListingPage['seoSegmentationStats'] | null
): SEOSegmentationStatsSuccess['caregiverStats'] => {
  return seoSegmentationStats?.__typename === 'SEOSegmentationStatsSuccess'
    ? seoSegmentationStats.caregiverStats
    : null;
};
